import { h, FunctionComponent } from 'preact';
import FullSite from './full-site';
import { TournamentListContent } from '../desktop-pages/TournamentListPage';

// Mobile page component for the Tournament List.
// It uses the mobile FullSite wrapper and the shared content component.
export const MobileTournamentListPage: FunctionComponent = () => {
    return (
        <FullSite>
            <TournamentListContent />
        </FullSite>
    );
};